import {inject, Injectable} from "@angular/core";
import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from "@angular/common/http";
import {finalize, Observable} from "rxjs";
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";

@Injectable({
  providedIn: 'root'
})
export class NetworkInterceptorHandler {

  totalRequests = 0;
  completedRequests = 0;

  constructor(private loader: LoadingService) {
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    this.loader.show();
    this.totalRequests++;
    return next(req).pipe(
      finalize(() => {
        this.completedRequests++;

        if (this.completedRequests == this.totalRequests) {
          this.loader.hide();
          this.completedRequests = 0;
          this.totalRequests = 0;
        }
      })
    )
  }
}

export const networkInterceptorFn: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const handler = inject(NetworkInterceptorHandler);
  return handler.intercept(req, next);
}
